import { type TerminologyItemAttributes } from './generated/TerminologyItemAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';

interface TerminologyItem extends TerminologyItemAttributes {}

@model
class TerminologyItem extends ApplicationModel {
  // Start auto-generated
  static typename: 'TerminologyItem' = 'TerminologyItem';
  get typename(): 'TerminologyItem' {
    return 'TerminologyItem';
  }

  static fields = {
    normal: attr({ readable: true }),
    plural: attr({ readable: true }),
  };
  // End auto-generated
}

export default TerminologyItem;
